// extracted by mini-css-extract-plugin
export default {"logoContainer":"ErrorPage_logoContainer__jIcim","logo":"ErrorPage_logo__h8N3X","errorMessage":"ErrorPage_errorMessage__0fD4C"};